import React from "react";
// import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, Rocket } from "lucide-react";
import { EmptyState } from "../../shared/ui";
import { useWorkspace } from "../../context/WorkspaceContext";
import DeploymentSummaryWidgets from "../components/Cards/DeploymentSummaryWidegets";
import DeploymentHistoryTable from "../components/Tables/DeploymentHistoryTable";
import "../styles/golive.css";

export default function RunListPage() {
  const navigate = useNavigate();
  const { currentEngagementId } = useWorkspace();

  return (
    <div className="gl-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="gl-h1">Run History</h1>
          <p className="mt-0.5 text-sm text-slate-500">
            All deployment runs, newest first · auto-refreshes every 5 s
          </p>
        </div>
        <div className="flex gap-2">
          <button className="gl-btn primary" onClick={() => navigate("/golive/new")}>
            <Plus size={14} /> New Deployment
          </button>
        </div>
      </div>

      {!currentEngagementId ? (
        <EmptyState
          icon={Rocket}
          title="No project selected"
          description="Select a project from the switcher above to see its deployments."
        />
      ) : (
        <>
          <DeploymentSummaryWidgets engagementId={currentEngagementId} />
          <DeploymentHistoryTable engagementId={currentEngagementId} />
        </>
      )}
    </div>
  );
}
